import { useState } from 'react';

const useNewProjectLogic = () => {
  const [loading, setLoading] = useState(false);

  return {
    loading
  };
};

export default useNewProjectLogic; 